import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { LoadingService } from '../../loading/loading.service';
import { take, finalize } from 'rxjs';
import { AlertComponent } from '../../alert/alert.component';
import { ProjetosService } from 'src/app/modules/services/projetos/projetos.service';
import { SafeUrl } from '@angular/platform-browser';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { FileManagerConfig } from 'src/app/modules/shared/file-manager/file-manager.interface';
import { AprovarAnaliseComponent } from 'src/app/modules/shared/modals/aprovar-analise/aprovar-analise.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { ModalController } from '@ionic/angular';
import { ModalResponsavelComponent } from 'src/app/modules/shared/modals/modal-responsavel/modal-responsavel.component';
import { ModalInteracoesAnaliseComponent } from 'src/app/modules/shared/modals/modal-interacoes-analise/modal-interacoes-analise.component';
import { AfericaoAmpliacaoService } from 'src/app/modules/services/afericao-ampliacao/afericao-ampliacao.service';

interface UploadedFile {
  file: File;
  url: SafeUrl;
  isImage: boolean;
}

@Component({
  selector: 'app-detail-projetos',
  templateUrl: './detail-projetos.component.html',
  styleUrls: ['./detail-projetos.component.scss'],
})
export class DetailProjetosComponent {
  idAfericao: string = '';
  afericao: any;
  files: UploadedFile[] = [];
  firstLine: any = [];
  secondtLine: any = [];
  documentsForView: any = [];
  imagens: any[] = [];
  arquivos: string[] = [];
  filesAdded: {
    nomeArquivo: string;
    tipoMime: string;
    categoria: string;
    subCategoria: string;
    objetoOriginal: File;
  }[] = [];
  extensoesImagem = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.tiff'];
  private imagePageIndex = 0;
  private readonly imagesPerPage = 8;
  private documentPageIndex = 0;
  private readonly documentsPerPage = 4;
  editing: boolean = false;
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc',
  };
  sortStateAnalise = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc',
  };
  dataSource = new MatTableDataSource<any>([]);
  dataSourceAnalise = new MatTableDataSource<any>([]);
  displayedColumns: string[] = [];
  displayedColumnsAnalise: string[] = [];
  columnConfig: any[] = [
    {
      columnDef: 'disciplina',
      header: 'Disciplina',
      property: 'disciplina.nome',
    },
    {
      columnDef: 'volume',
      header: 'Volume',
      property: 'disciplina.volume.nome',
    },
    {
      columnDef: 'statusAtual',
      header: 'Status',
      property: 'statusAtual',
      customTd: true,
    },
    { columnDef: 'actions', header: 'Ações', custom: true },
  ];
  columnConfigAnalise: any[] = [
    { columnDef: 'revisao', header: 'Revisão', property: 'revisao' },
    {
      columnDef: 'responsavel',
      header: 'Responsável',
      property: 'responsavel',
    },
    {
      columnDef: 'dataCadastro',
      header: 'Data de cadastro',
      property: 'dataCadastroAnaliseProjeto',
      customTd: true,
    },
    {
      columnDef: 'prazo',
      header: 'Prazo',
      property: 'prazoAnaliseProjeto',
      customTd: true,
    },
    {
      columnDef: 'dataEncerramento',
      header: 'Data de encerramento',
      property: 'dataEncerramentoAnaliseProjeto',
      customTd: true,
    },
    {
      columnDef: 'status',
      header: 'Status',
      property: 'statusAnaliseProjeto',
      customTd: true,
    },
    { columnDef: 'actions', header: 'Ações', custom: true },
  ];
  pageIndex: number = 0;
  pageSize: number = 10;
  restoreExpandedId: string | null = null;
  totalPages: number = 1;
  totalElements: number = 0;
  pageIndexAnalise: number = 0;
  pageSizeAnalise: number = 10;
  totalPagesAnalise: number = 1;
  totalElementsAnalise: number = 0;
  loadingAnalises: boolean = false;
  erroAnalises: string = '';
  analisesCarregadas: boolean = false;
  fileConfig: FileManagerConfig = {
    permitirUpload: false,
    permitirBaixarTodos: false,
    permitirReiniciar: false,
    modoEdicao: false,
  };
  idProjeto: any;
  transicaoId: any;
  statusAtualId: any;
  afericaoInformacoesComplementares:any;
  selectedTabIndex: number = 0;
  analisesProjeto:any;
  // Análise por disciplina (Executivo)
  disciplinaSelecionada: any = null;
  analiseDisciplina: any;
  analiseDisciplinaDataSource = new MatTableDataSource<any>([]);
  displayedColumnsDisciplinaAnalise: string[] = [];
  columnConfigDisciplinaAnalise: any[] = [
    { columnDef: 'revisao', header: 'Revisão', property: 'revisao' },
    { columnDef: 'responsavel', header: 'Responsável', property: 'responsavel' },
    { columnDef: 'dataCadastro', header: 'Data de cadastro', property: 'dataCadastroAnaliseProjeto', customTd: true },
    { columnDef: 'prazo', header: 'Prazo', property: 'prazoAnaliseProjeto', customTd: true },
    { columnDef: 'dataEncerramento', header: 'Data de encerramento', property: 'dataEncerramentoAnaliseProjeto', customTd: true },
    { columnDef: 'status', header: 'Status', property: 'statusAnaliseProjeto', customTd: true },
    { columnDef: 'actions', header: 'Ações', custom: true },
  ];
  sortStateDisciplinaAnalise = { sortProperty: 'criadoEm', sortDirection: 'desc' };
  pageIndexDisciplinaAnalise: number = 0;
  pageSizeDisciplinaAnalise: number = 10;
  totalPagesDisciplinaAnalise: number = 1;
  totalElementsDisciplinaAnalise: number = 0;
  loadingAnaliseDisciplina: boolean = false;
  erroAnaliseDisciplina: string = '';
  constructor(
    private route: ActivatedRoute,
    private projetosService: ProjetosService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private router: Router,
    private pageSizeService: PageSizeService,
    private toastService: ToastService,
    public dialog: MatDialog,
    private modalCtrl: ModalController,
    private afericaoAmpliacaoService: AfericaoAmpliacaoService
  ) {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.idAfericao = params.get('id') ?? '';
      this.getData(this.idAfericao);
      this.getListDisciplinas();
    });
    this.displayedColumns = this.columnConfig.map((col) => col.columnDef);
    this.displayedColumnsAnalise = this.columnConfigAnalise.map(
      (col) => col.columnDef,
    );
    this.displayedColumnsDisciplinaAnalise = this.columnConfigDisciplinaAnalise.map(col => col.columnDef);
  }

  getData(idAfericao: string): void {
    this.projetosService
      .getProjeto(idAfericao)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading()),
      )
      .subscribe({
        next: (res: any) => {
          this.afericao = res;
          this.getDataObra(this.afericao.parametroServicoAmpliacao.id);
          this.processarDisciplinas();
          this.processarArquivos();
        },
        error: (erro: any) => this.handleRequestError(erro),
      });
  }

    // Requisição da aferição inicial
  getDataObra(idAfericao: string): void {
    this.afericaoAmpliacaoService
      .getAfericaoAmpliacao(idAfericao)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          this.afericaoInformacoesComplementares = res;
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }

  getListDisciplinas(pageIndex: number = 0, keepExpandedId?: string) {
    this.projetosService
      .getDisciplinasCadastradasPorIdPaginada(
        this.pageSize,
        pageIndex,
        this.sortState.sortDirection,
        this.sortState.sortProperty,
        this.idAfericao,
      )
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading()),
      )
      .subscribe({
        next: (res: any) => {
          const { content, pageSize, totalPages, totalElements, pageNumber } =
            res;
          this.dataSource.data = content;
          this.pageSize = pageSize;
          this.totalPages = totalPages;
          this.totalElements = totalElements;
          this.pageIndex = pageNumber;

          if (keepExpandedId) {
            this.restoreExpandedId = null;
            setTimeout(() => { this.restoreExpandedId = keepExpandedId; }, 0);
          }
        },
        error: (erro: any) => this.handleRequestError(erro),
      });
  }

  onPanelAnalisesOpened(): void {
    if (!this.analisesCarregadas && !this.loadingAnalises) {
      this.getListAnalisesProjeto();
    }
  }

  getListAnalisesProjeto(pageIndex: number = 0): void {
    this.loadingAnalises = true;
    this.erroAnalises = '';

    this.projetosService
      .getAnalisesProjeto(
        this.pageSizeAnalise,
        pageIndex,
        this.sortStateAnalise.sortDirection,
        this.sortStateAnalise.sortProperty,
        this.idAfericao,
      )
      .pipe(
        take(1),
        finalize(() => (this.loadingAnalises = false)),
      )
      .subscribe({
        next: (res: any) => {
          const { content, pageSize, totalPages, totalElements, pageNumber } =
            res;
          this.analisesProjeto = content;
          this.dataSourceAnalise.data = (content || []).map((item: any) => ({
            ...item,
            revisao: this.formatarRevisao(item.revisao),
            responsavel:item?.responsavel?.nome,
            dataCadastroAnaliseProjeto: item.dataCadastro,
            prazoAnaliseProjeto: item.prazo,
            dataEncerramentoAnaliseProjeto: item.dataEncerramento,
            statusAnaliseProjeto:
              item.status?.statusAtual?.nome || item.statusAtual || '-',
            interacoes: item.interacoes || [],
          }));
          this.pageSizeAnalise = pageSize;
          this.totalPagesAnalise = totalPages;
          this.totalElementsAnalise = totalElements;
          this.pageIndexAnalise = pageNumber;
          this.analisesCarregadas = true;
        },
        error: () => {
          this.erroAnalises = 'Erro ao carregar análises';
        },
      });
  }

  pageChangeEvent(event: PageEvent) {
    if (this.pageSize !== event.pageSize) {
      this.pageSize = event.pageSize;
      this.pageSizeService.setPageSize(event.pageSize);
      return this.getListDisciplinas(0);
    }

    if (this.pageIndex !== event.pageIndex) {
      return this.getListDisciplinas(event.pageIndex);
    }
  }

  pageChangeEventAnalise(event: PageEvent) {
    if (this.pageSizeAnalise !== event.pageSize) {
      this.pageSizeAnalise = event.pageSize;
      this.pageSizeService.setPageSize(event.pageSize);
      return this.getListAnalisesProjeto(0);
    }

    if (this.pageIndexAnalise !== event.pageIndex) {
      return this.getListAnalisesProjeto(event.pageIndex);
    }
  }

  onSortChange(sortProperty: any): void {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }
    this.getListDisciplinas();
  }

  onSortChangeAnalise(sortProperty: any): void {
    if (this.sortStateAnalise.sortProperty === sortProperty) {
      this.sortStateAnalise.sortDirection =
        this.sortStateAnalise.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortStateAnalise.sortProperty = sortProperty;
      this.sortStateAnalise.sortDirection = 'asc';
    }
    this.getListAnalisesProjeto();
  }

  transitionStatusChangedAnalise(event: any): void {
    if (!event || !event.data) {
      return;
    }

    const idProjeto = event.data.id;
    const transicaoId = event.transicaoId;
    const statusAtualId = event.data.status?.statusAtual?.id;
    const transicaoNome = event.transicaoNome;
    this.idProjeto = idProjeto;
    this.transicaoId = transicaoId;
    this.statusAtualId = statusAtualId;
    const transicaoStatusRequestData = {
      idExterno: idProjeto,
      idStatusAtual: statusAtualId,
      idTransicao: transicaoId,
    };
    const formData = new FormData();
    formData.append(
      'request',
      new Blob([JSON.stringify(transicaoStatusRequestData)], {
        type: 'application/json',
      }),
    );
    switch (event.transicaoNome) {
      case 'Enviar para análise interna':
      case 'Enviar para análise supervisora':
      case 'Enviar relatório de análise':
      case 'Devolver para análise supervisora':
        this.openAnalyzeDialog(idProjeto, statusAtualId, transicaoId);
        break;

      case 'Encerrar análise':
        this.openAnalyzeDialog(
          idProjeto,
          statusAtualId,
          transicaoId,
          true,
          true,
        );
        break;

      default:
        this.openAnalyzeDialog(idProjeto, statusAtualId, transicaoId);
        break;
    }
  }
  openAnalyzeDialog(
    idAnalise: string,
    statusAtualId: string,
    transicaoId: string,
    isEncerrarAnalise?: boolean,
    mostrarParecer?: boolean,
  ): void {

    const analise = this.analisesProjeto.find((item: any) => item.id == idAnalise);
    
    const dialogRef = this.dialog.open(AprovarAnaliseComponent, {
      width: '1550px',
      data: {
        idAnaliseAfericao: idAnalise,
        statusAtualId: statusAtualId,
        transicaoId: transicaoId,
        isFromProjectDetail: true,
        isEncerrarAnalise: isEncerrarAnalise,
        mostrarParecer: mostrarParecer,
        cnpj: this.afericao.contrato.company.cnpj,
        responsavel: analise && analise.responsavel ? analise.responsavel : null
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.transitionStatusAnalise(result);
      }
    });
  }
  transitionStatusAnalise(formData: FormData): void {
    this.loadingService.showLoading();

    this.projetosService
      .postTransicaoStatusAnalise(this.idAfericao, formData)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading()),
      )
      .subscribe({
        next: () => {
          this.getListAnalisesProjeto(this.pageIndexAnalise);
          this.toastService.showSuccess(
            'Mudança de status realizada com sucesso',
          );
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        },
      });
  }

  openViewAnalise(event: any): void {
    const interacao = event?.data?.interacoes?.find(
      (item: any) => item.id == event.idAnalise,
    );

    this.router.navigate(
      [
        `detail-afericao/${this.idAfericao}/${event?.data?.id}/${event?.idAnalise}/projeto-funcional/view`,
      ],
      {
        state: {
          interacaoAnalise: interacao,
        },
      },
    );
  }

  private handleRequestError(erro: any): void {
    if (erro.status !== 500 && erro.status) {
      this.openSnackBar(erro.error.message, 'error');
    } else if (erro.error?.error === 'Unprocessable Entity') {
      this.openSnackBar(erro.error.message, 'warning');
    } else {
      this.openSnackBar(
        'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
        'error',
      );
    }
  }

  openSnackBar(description: string, type: string): void {
    const classMap: Record<string, string> = {
      sucess: 'snacbar-sucess',
      warning: 'snacbar-warning',
      error: 'snacbar-error',
    };

    const classSnack = classMap[type] || 'snacbar-default';

    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description, type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  close(): void {
    this.router.navigate(['projetos']);
  }

  private updateDocumentView(): void {
    const start = this.documentPageIndex * this.documentsPerPage;
    this.documentsForView = this.arquivos.slice(
      start,
      start + this.documentsPerPage,
    );
  }

  prevDocuments(): void {
    if (this.documentPageIndex > 0) {
      this.documentPageIndex--;
      this.updateDocumentView();
    }
  }

  nextDocuments(): void {
    const maxPages = Math.ceil(this.arquivos.length / this.documentsPerPage);
    if (this.documentPageIndex < maxPages - 1) {
      this.documentPageIndex++;
      this.updateDocumentView();
    }
  }

  get imageFiles(): UploadedFile[] {
    return this.files.filter((f) => f.isImage);
  }

  get otherFiles(): UploadedFile[] {
    return this.files.filter((f) => !f.isImage);
  }

  private updateImageLines(): void {
    const start = this.imagePageIndex * this.imagesPerPage;
    const pageImages = this.imagens.slice(start, start + this.imagesPerPage);

    this.firstLine = pageImages.slice(0, 4);
    this.secondtLine = pageImages.slice(4, 8);
  }

  removeImg(img: any) {
    this.imagens = this.imagens.filter(
      (photo: any) => photo.fileName != img.fileName,
    );
    this.filesAdded = this.filesAdded.filter(
      (arq: any) => arq.nomeArquivo != img.fileName,
    );
    this.organizeImages();
  }

  removeFile(file: any) {
    this.arquivos = this.arquivos.filter((arq: any) => arq != file);
    this.filesAdded = this.filesAdded.filter(
      (arq: any) => arq.nomeArquivo != file,
    );
    this.organizeDocuments();
  }

  private organizeImages(): void {
    this.firstLine = this.imagens.slice(0, 4);
    this.secondtLine = this.imagens.slice(4, 8);
  }

  private organizeDocuments(): void {
    this.updateDocumentView();
  }

  downloadFile(doc: any, type: 'executivo' | 'funcional'): void {
    if (type == 'funcional') {
      if (!doc.sasURL) {
        this.openSnackBar('Link para download indisponível', 'warning');
      } else {
        window.open(doc.sasURL, '_blank');
      }
    } else {
      if (!doc.url) {
        this.openSnackBar('Link para download indisponível', 'warning');
      } else {
        window.open(doc.url, '_blank');
      }
    }
  }

  processarDisciplinas() {
    if (!this.afericao || !this.afericao.disciplinas) return;

    this.afericao.disciplinas.forEach((disciplina: any) => {
      disciplina.paginaImagem = 0;

      disciplina.imagens = disciplina.arquivos.filter((arquivo: any) => {
        const extensao = arquivo.nomeArquivo
          .slice(arquivo.nomeArquivo.lastIndexOf('.'))
          .toLowerCase();
        return this.extensoesImagem.includes(extensao);
      });

      disciplina.documentos = disciplina.arquivos.filter((arquivo: any) => {
        const extensao = arquivo.nomeArquivo
          .slice(arquivo.nomeArquivo.lastIndexOf('.'))
          .toLowerCase();
        return !this.extensoesImagem.includes(extensao);
      });
    });
  }

  processarArquivos() {
    if (!this.afericao || !this.afericao.arquivos) return;

    this.afericao.paginaImagem = 0;

    this.afericao.imagens = this.afericao.arquivos.filter((arquivo: any) => {
      const extensao = arquivo.nomeArquivo
        .slice(arquivo.nomeArquivo.lastIndexOf('.'))
        .toLowerCase();
      return this.extensoesImagem.includes(extensao);
    });

    this.afericao.documentos = this.afericao.arquivos.filter((arquivo: any) => {
      const extensao = arquivo.nomeArquivo
        .slice(arquivo.nomeArquivo.lastIndexOf('.'))
        .toLowerCase();
      return !this.extensoesImagem.includes(extensao);
    });
  }

  nextImages(disciplina: any) {
    if ((disciplina.paginaImagem + 1) * 8 < disciplina.imagens.length) {
      disciplina.paginaImagem++;
    }
  }

  prevImages(disciplina: any) {
    if (disciplina.paginaImagem > 0) {
      disciplina.paginaImagem--;
    }
  }

  downloadAll(disciplina: any) {
    if (!disciplina || !disciplina.arquivos) return;
    if (this.afericao?.tipoProjeto.nome == 'Funcional') {
      this.afericao.arquivos.forEach((arquivo: any) => {
        if (arquivo) {
          this.downloadFile(arquivo, 'funcional');
        } else {
          this.openSnackBar('Link para download indisponível!', 'warning');
        }
      });
    } else {
      disciplina.arquivos.forEach((arquivo: any) => {
        if (arquivo) {
          this.downloadFile(arquivo, 'executivo');
        }
      });
    }
  }

  onDisciplinaSelected(disciplina: any): void {
    this.pageIndexDisciplinaAnalise = 0;
    this.analiseDisciplinaDataSource.data = [];
    this.erroAnaliseDisciplina = '';
    this.getAnaliseDisciplina();
  }

  getAnaliseDisciplina(pageIndex: number = 0): void {
    if (!this.disciplinaSelecionada) return;
    this.loadingAnaliseDisciplina = true;
    this.erroAnaliseDisciplina = '';
    this.projetosService
      .getAnaliseDisciplina(
        this.pageSizeDisciplinaAnalise, pageIndex,
        this.sortStateDisciplinaAnalise.sortDirection,
        this.sortStateDisciplinaAnalise.sortProperty,
        this.idAfericao, this.disciplinaSelecionada.id
      )
      .pipe(take(1), finalize(() => (this.loadingAnaliseDisciplina = false)))
      .subscribe({
        next: (res: any) => {
          const { content, pageSize, totalPages, totalElements, pageNumber } = res;
          this.analiseDisciplina = content;
          this.analiseDisciplinaDataSource.data = (content || []).map((item: any) => ({
            ...item,
            revisao: this.formatarRevisao(item.revisao),
            responsavel: item?.responsavel?.nome,
            dataCadastroAnaliseProjeto: item.dataCadastro,
            prazoAnaliseProjeto: item.prazo,
            dataEncerramentoAnaliseProjeto: item.dataEncerramento,
            statusAnaliseProjeto: item.status?.statusAtual?.nome || item.statusAtual || '-',
            interacoes: item.interacoes || [],
          }));
          this.pageSizeDisciplinaAnalise = pageSize;
          this.totalPagesDisciplinaAnalise = totalPages;
          this.totalElementsDisciplinaAnalise = totalElements;
          this.pageIndexDisciplinaAnalise = pageNumber;
        },
        error: () => {
          this.erroAnaliseDisciplina = 'Erro ao carregar análises da disciplina';
        },
      });
  }

  pageChangeEventDisciplinaAnalise(event: PageEvent): void {
    if (this.pageSizeDisciplinaAnalise !== event.pageSize) {
      this.pageSizeDisciplinaAnalise = event.pageSize;
      this.pageSizeService.setPageSize(event.pageSize);
      return this.getAnaliseDisciplina(0);
    }
    if (this.pageIndexDisciplinaAnalise !== event.pageIndex) {
      return this.getAnaliseDisciplina(event.pageIndex);
    }
  }

  onSortChangeDisciplinaAnalise(sortProperty: any): void {
    if (this.sortStateDisciplinaAnalise.sortProperty === sortProperty) {
      this.sortStateDisciplinaAnalise.sortDirection =
        this.sortStateDisciplinaAnalise.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortStateDisciplinaAnalise.sortProperty = sortProperty;
      this.sortStateDisciplinaAnalise.sortDirection = 'asc';
    }
    this.getAnaliseDisciplina();
  }

  transitionStatusChangedAnaliseDisciplina(event: any): void {
    if (!event || !event.data) return;
    const idAnalise = event.data.id;
    const statusAtualId = event.data.status?.statusAtual?.id;
    const transicaoId = event.transicaoId;
    const isEncerrarAnalise = event.transicaoNome === 'Encerrar análise';

    this.openAnalyzeDialogDisciplina(idAnalise, statusAtualId, transicaoId, isEncerrarAnalise, isEncerrarAnalise);
  }

  openAnalyzeDialogDisciplina(
    idAnalise: string, statusAtualId: string, transicaoId: string,
    isEncerrarAnalise?: boolean, mostrarParecer?: boolean
  ): void {
    const analise = this.analiseDisciplina?.find((item: any) => item.id == idAnalise);
    const dialogRef = this.dialog.open(AprovarAnaliseComponent, {
      width: '1550px',
      data: {
        idAnaliseAfericao: idAnalise,
        statusAtualId,
        transicaoId,
        isFromProjectDetail: true,
        isEncerrarAnalise,
        mostrarParecer,
        cnpj: this.afericao?.contrato?.company?.cnpj,
        responsavel: analise?.responsavel ?? null,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.transitionStatusAnaliseDisciplina(result);
    });
  }

  transitionStatusAnaliseDisciplina(formData: FormData): void {
    if (!this.disciplinaSelecionada) return;
    this.loadingService.showLoading();
    this.projetosService
      .postTransicaoStatusAnaliseDisciplina(this.idAfericao, this.disciplinaSelecionada.id, formData)
      .pipe(take(1), finalize(() => this.loadingService.hideLoading()))
      .subscribe({
        next: () => {
          const keepExpandedId = this.disciplinaSelecionada?.id;
          this.getListDisciplinas(this.pageIndex, keepExpandedId);
          this.toastService.showSuccess('Mudança de status realizada com sucesso');
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        },
      });
  }

  editResponsavelAnaliseDisciplina(idAnalise: any): void {
    const analise = this.disciplinaSelecionada?.analises?.find((item: any) => item.id == idAnalise);
    const dialogRef = this.dialog.open(ModalResponsavelComponent, {
      width: '700px',
      data: {
        id: idAnalise,
        projectId: this.idAfericao,
        disciplinaId: this.disciplinaSelecionada?.id,
        responsavel: analise?.responsavel ?? null,
        prazo: analise?.prazo ?? null,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && this.disciplinaSelecionada) {
        delete this.disciplinaSelecionada.analises;
        this.onDisciplinaRowExpanded(this.disciplinaSelecionada);
      }
    });
  }

  onDisciplinaRowExpanded(row: any): void {
    if (row.analises !== undefined) return;
    row.analises = null;
    this.projetosService
      .getAnaliseDisciplina(100, 0, 'desc', 'revisao', this.idAfericao, row.id)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          row.analises = (res.content || []).map((item: any) => ({
            ...item,
            revisaoDisplay: this.formatarRevisao(item.revisao),
            responsavelNome: item?.responsavel?.nome ?? '-',
            statusNome: item.status?.statusAtual?.nome || item.statusAtual || '-',
          }));
        },
        error: () => { row.analises = []; },
      });
  }

  onAnaliseDisciplinaAction(event: any): void {
    const { action, disciplina, analise } = event;
    this.disciplinaSelecionada = disciplina;
    switch (action) {
      case 'tramitar':
        this.transitionStatusChangedAnaliseDisciplina({
          data: analise,
          transicaoId: event.transicaoId,
          transicaoNome: event.transicaoNome,
        });
        break;
      case 'editar':
        this.editResponsavelAnaliseDisciplina(analise.id);
        break;
      case 'historico':
        this.openDialogHistoricoAnaliseDisciplina(analise.id);
        break;
      case 'view':
        this.openModalInteracoesAnalise(disciplina, analise);
        break;
    }
  }

  openModalInteracoesAnalise(disciplina: any, analise: any): void {
    this.dialog.open(ModalInteracoesAnaliseComponent, {
      width: '1200px',
      data: {
        disciplinaNome: disciplina.disciplina?.nome ?? '-',
        volumeNome: disciplina.disciplina?.volume?.nome ?? '-',
        revisaoDisplay: analise.revisaoDisplay,
        interacoes: analise.interacoes || [],
        idAfericao: this.idAfericao,
        analiseId: analise.id,
      },
    });
  }

  async openDialogHistoricoAnaliseDisciplina(id: any): Promise<void> {
    const data = {
      type: 'analiseDisciplina',
      id,
      projectId: this.idAfericao,
      disciplinaId: this.disciplinaSelecionada?.id,
      fieldMappings: { responsavel: 'Responsável' },
    };
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: { data, fieldMappings: data.fieldMappings },
    });
    modal.present();
  }

  private formatarRevisao(revisao: any): string {
    if (revisao === null || revisao === undefined || revisao === '') {
      return '-';
    }

    if (!isNaN(Number(revisao))) {
      return String(revisao).padStart(3, '0');
    }

    return String(revisao);
  }

  private buildAnaliseProjetoTransitionFormData(event: any): FormData {
    const payloadAnaliseProjeto = {
      idExterno: event.data.id,
      idStatusAtual: event.data.status?.statusAtual?.id,
      idTransicao: event.transicaoId,
      comentario: null,
      idTipoParecer: null,
      arquivosGerais: [],
      arquivosART: [],
    };

    const formData = new FormData();
    formData.append(
      'request',
      new Blob([JSON.stringify(payloadAnaliseProjeto)], {
        type: 'application/json',
      }),
    );

    return formData;
  }
  async openDialogHistoricoAnaliseProjeto(id: any) {
    const data = {
      type: 'analiseProjeto',
      id: id,
      projectId: this.idAfericao,
      fieldMappings: {
        responsavel: 'Responsável',
      },
    };
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: { data, fieldMappings: data.fieldMappings },
    });
    modal.present();
  }

  transitionDisciplineStatusChanged(event: any): void {
    if (!event || !event.data) return;

    const disciplina = event.data;
    const idExterno = disciplina.id;
    const idStatusAtual = disciplina.status?.statusAtual?.id;
    const transicaoNome = event.transicaoNome;
    const isAguardandoRevisao = disciplina.statusAtual === 'Aguardando revisão';

    if (transicaoNome === 'Enviar para análise' && isAguardandoRevisao) {
      this.openDisciplineAnalyzeDialog(idExterno, idStatusAtual, event.transicaoId);
      return;
    }

    const payload = { idExterno, idStatusAtual, idTransicao: event.transicaoId };
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    this.transitionDisciplineStatus(formData);
  }

  openDisciplineAnalyzeDialog(idExterno: string, idStatusAtual: string, transicaoId: string): void {
    const dialogRef = this.dialog.open(AprovarAnaliseComponent, {
      width: '1550px',
      data: {
        idAnaliseAfericao: idExterno,
        statusAtualId: idStatusAtual,
        transicaoId: transicaoId,
        fromProjetos: true,
        isDisciplina: true,
        cnpj: this.afericao?.contrato?.company?.cnpj,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.transitionDisciplineStatus(result);
      }
    });
  }

  transitionDisciplineStatus(formData: FormData): void {
    this.loadingService.showLoading();

    this.projetosService
      .postTransicaoStatusDisciplina(this.idAfericao, formData)
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading()),
      )
      .subscribe({
        next: () => {
          this.getListDisciplinas(this.pageIndex);
          this.toastService.showSuccess('Mudança de status da disciplina realizada com sucesso');
        },
        error: (erro: any) => {
          if (erro.status !== 500 && erro.status) {
            this.toastService.showError(erro.error.message);
          } else {
            this.toastService.showError();
          }
        },
      });
  }

  async openDialogHistoricoDisciplina(idDisciplina: any): Promise<void> {
    const data = {
      type: 'disciplinaProjeto',
      id: idDisciplina,
      projectId: this.idAfericao,
      fieldMappings: {
        statusAtual: 'Status',
        numRevisao: 'Revisão',
      },
    };
    const modal = await this.modalCtrl.create({
      component: ModalHistoricComponent,
      componentProps: { data, fieldMappings: data.fieldMappings },
    });
    modal.present();
  }

  editResponsavel(idAnalise: any) {
    const analise = this.analisesProjeto.find((item: any) => item.id == idAnalise);
    const dialogRef = this.dialog.open(ModalResponsavelComponent, {
      width: '700px',
      data: {
        id: idAnalise,
        projectId: this.idAfericao,
        responsavel: analise && analise.responsavel ? analise.responsavel : null,
        prazo: analise?.prazo ?? null,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
        this.getListAnalisesProjeto();
    });
  }
}
